module.exports = __webpack_public_path__ + "img/schedule_black_24dp.6fac29dc.svg";